module.exports = __webpack_public_path__ + "static/media/AirPurifiersbanner.4b163eee.jpg";